import React, {Component} from "react";
import Corm from "./Corm";
import Usa from "./Usa";
import Tyrehub from "./tyrehub/Tyrehub";
import QuickScan from "./tyrehub/QuickScan";
import DetailNew from "./DetailNew";
import Dill from "./Dill";
import Dach from "./Dach";

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            report: null,
        }
    };

    componentDidMount() {
        this.getRecordDetail();
    }

    // 获取检测报告详情
    getRecordDetail() {
        global.Api.getReportsDetail(this.props.match.params.id).then(res => {
            if (res.data.code === 0) {
                this.setState({
                    report: res.data.data.report
                });
            } else {
                console.log(res.data.message);
            }
        });
    }


    render() {
        if (this.state.report) {
            let {
                model_number,
                recordtype
            } = this.state.report;

            const returnComponent = (model, data) => {
                switch (model) {
                    case 'cormach.tyrescan.ts004':
                        return <Corm uuid={data.uuid}/>;
                    // case 'nam.tyrescan.ts004':
                    //     return <Tyrehub data={{reportData: data}}/>;
                    case 'sa.tyrescan.ts004':
                        return <Usa uuid={data.uuid}/>;
                    case 'dill.tyrescan.ts004':
                        return <Dill uuid={data.uuid}/>;
                    case 'dach.tyrescan.ts004':
                            return <Dach data={data}/>;
                    default:
                        if (recordtype==='quickscan'){
                            return <QuickScan data={{reportData: data}}/>;
                        }
                        return <DetailNew data={data}/>;
                }

            };

            return (
                <div>
                    {returnComponent(model_number, this.state.report)}
                </div>
            )

        } else {
            return (<div></div>)
        }

    }
}

export default Detail;